<template>
   <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          Journals
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:500px" class="text-left">Title</th>
                    <th style="width:200px" class="text-left">Institution</th>
                    
                    <th style="width: 200px">ISSN</th>
                    <th class="text-left">Journal Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id" >
                    <td>{{ item.Title }}</td>
                    <td>{{ item.Publisher }}</td>
                    <td>{{ item.ISSN }}</td>
                    <td>{{ getJournalType(item.JournalType) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'PublicationList',
  computed: {
  },
  created() {
    
  },
  methods: {
    open(list) {
        this.dialog = true;
        this.list = list;
    },
    cancel() {
        this.dialog = false;
        this.list = [];
    },
    getJournalType(id) {
      switch (id) {
        case 1:
          return "Academic Journals";
        case 2:
          return "Personal Journals";
        case 3:
          return "Professional Journals";
      }
    },
  },
  props: {
  },
  computed: {
  },
  watch: {
    notify() {
    },
  },
  data() {
    return {
      list: [],
      dialog: false,
      options: {
        color: "primary",
        width: 1200,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/InstitutionList.vue